import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import {
  fetchData,
  selectIsLoading,
  selectUser,
  selectTilesDetails,
  selectRestrictedDataError,
  selectActiveSubscription, // <<< ZMIANA: Import selektora subskrypcji
  fetchActiveSubscription, // <<< ZMIANA: Import akcji pobierania subskrypcji
} from "../../mainApp/features/DataSlice/dataSlice";
import HomeWrapper from "./homeWrapper";
import LoadingPage from "../components/TechnicalTabs/LoadingPage";
import ErrorPage from "../../mainApp/features/TechnicalTabs/ErrorPage";
import { handleUnauthorizedAccess } from "./Utility/handleUnauthorizedAccess";
import { useNavigate } from "react-router-dom";
import { auth, db } from "./firebase";
import { doc, getDoc } from "firebase/firestore";

const Home = () => {
  const isLoading = useSelector(selectIsLoading);
  const user = useSelector(selectUser);
  const tilesDetails = useSelector(selectTilesDetails);
  const restrictedDataError = useSelector(selectRestrictedDataError);
  const activeSubscription = useSelector(selectActiveSubscription); // <<< ZMIANA: Pobranie stanu subskrypcji
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [userDetails, setUserDetails] = useState(null);
  const [initialLoading, setInitialLoading] = useState(true);

  // <<< ZMIANA: Logika sprawdzająca plan Standard (skopiowana z Chatbot.js)
  const STANDARD_MONTHLY_ID = process.env.REACT_APP_STANDARD_MONTHLY;
  const STANDARD_YEARLY_ID = process.env.REACT_APP_STANDARD_YEARLY;

  const isStandardPlan =
    activeSubscription &&
    (activeSubscription.priceId === STANDARD_MONTHLY_ID ||
      activeSubscription.priceId === STANDARD_YEARLY_ID);

  const delay = (ms) => new Promise((resolve) => setTimeout(resolve, ms));

  useEffect(() => {
    dispatch(fetchData());
  }, [dispatch]);

  useEffect(() => {
    dispatch(fetchData());
    const unsub = auth.onAuthStateChanged(async (u) => {
      if (u) {
        try {
          dispatch(fetchActiveSubscription()); // <<< ZMIANA: Wywołanie akcji pobrania subskrypcji
          const ref = doc(db, "Users", u.uid);
          const snap = await getDoc(ref);
          if (snap.exists()) {
            setUserDetails(snap.data());
          } else {
            setUserDetails(null);
            console.warn("Dokument użytkownika nie istnieje.");
          }
          // Dodajemy opóźnienie 500 ms jako dodatkowe zabezpieczenie
          await delay(500);
        } catch (error) {
          console.error("Błąd pobierania userDetails:", error);
          setUserDetails(null);
          // Opóźnienie również w przypadku błędu
          await delay(500);
        }
      } else {
        navigate("/login");
      }
      setInitialLoading(false);
    });
    return () => unsub();
  }, [dispatch, navigate]);

  if (initialLoading || isLoading === "loading") {
    return <LoadingPage />;
  }

  if (restrictedDataError) {
    navigate("/unauthorized");
  }

  let returned;

  switch (isLoading) {
    case "success":
      if (!userDetails) {
        // Zamiast natychmiastowego przekierowania, wyświetlamy LoadingPage
        returned = <LoadingPage/>;
      } else if (tilesDetails.length > 0 && user && userDetails) {
        returned = (
          <HomeWrapper
            tilesDetails={tilesDetails}
            isStandardPlan={isStandardPlan} // <<< ZMIANA: Przekazanie flagi do komponentu
          />
        );
      } else {
        returned = handleUnauthorizedAccess();
      }
      break;
    case "error":
      returned = <ErrorPage />;
      break;
    default:
      returned = <LoadingPage />;
  }

  return returned;
};

export default Home;